export default {
    getCurrentLocation: function () {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition((data) => {
                var lat = data.coords.latitude;
                var lng = data.coords.longitude;
                resolve({lat: lat, lng: lng});
            }, (error) => {
                reject(error);
            });
        });
    },
};
